import { DataGuard } from '@components/DataGuard'
import Disclaimer from '@components/Disclaimer'
import Panel from '@components/Panel'
import { For, Show, type ParentComponent } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import Card from './Card'
import { Header } from './Header'
import { ActiveFilters, SetupsSearch } from './Header/ActiveFilters'
import ListRow from './ListRow'
import { useList } from './state'
import { useInfiniteScroll } from './useInfiniteScroll'

const List: ParentComponent = () => {
  const { loadMore, hasMore, activeLayout, listQuery, viewMode, cardColumns } = useService(useList)()

  let scrollRef: HTMLDivElement | undefined

  useInfiniteScroll({
    targetRef: () => scrollRef,
    onBottomReach: () => {
      // Simply trigger loadMore if there is more data
      if (hasMore()) {
        loadMore()
      }
    },
  })

  return (
    <>
      <Header />
      <Panel
        ref={(el) => (scrollRef = el as HTMLDivElement)}
        pt={{ base: '24px', smDown: '14px' }}
        px={{ base: '22px', smDown: '12px' }}
        pb='60px'
        class={(css({
          position: 'relative',
          overflowY: 'auto',
          height: 'calc(var(--vh) * 100 - 84px)',
          pb: 0
        }))}
      >
        <SetupsSearch class={css({ display: { base: 'none', lgDown: 'flex' }, mb: '3' })} />
        <ActiveFilters />
        <DataGuard
          query={listQuery}
          emptyMessage="No setups match your search or filters"
        >
          {(setups) => (
            <Show
              when={viewMode() === 'card'}
              fallback={
                <main
                  class={css({
                    display: 'grid',
                    gridTemplateColumns: {
                      base: 'repeat(2, minmax(0, 1fr))',
                      smDown: '1fr'
                    },
                    gap: '14px',
                    alignItems: 'start',
                  })}
                >
                  <For each={setups}>
                    {(item) => <ListRow setup={item} />}
                  </For>
                </main>
              }
            >
              <main
                style={{ '--setup-cols': String(cardColumns()) }}
                class={css({
                  display: 'grid',
                  gap: '22px',
                  gridTemplateColumns: {
                    base: 'repeat(var(--setup-cols), 1fr)',
                    lgDown: 'repeat(2, 1fr)',
                    smDown: '1fr'
                  },
                })}
              >
                <For each={setups}>
                  {(item) => (
                    <Card
                      layout={activeLayout()}
                      setup={item}
                    />
                  )}
                </For>
              </main>
            </Show>
          )}
        </DataGuard>
      </Panel>
      <Disclaimer />
    </>
  )
}

export default List
